// extracted by mini-css-extract-plugin
export default {"HighlightedText":"COk0NjeRl4C8FRubi7jo"};